import Intercom, { hide, showNewMessage, shutdown } from '@intercom/messenger-js-sdk';

import { CurrentUser } from '../axios';

export const openIntercom = (message?: string) => {
  showNewMessage(message || '');
};

export const closeIntercom = () => {
  hide();
};

export const shutdownIntercom = () => {
  shutdown();
};

export const initializeIntercomWithUser = (currentUser: CurrentUser) => {
  Intercom({
    app_id: process.env.NODE_ENV === 'production' ? 'xxw0e0bv' : 'cji4j4b4',
    user_hash: currentUser?.intercom_user_hash,
    user_id: currentUser?.id?.toString(),
    name: currentUser?.username ? `${currentUser?.username} (${currentUser?.last_name})` : '',
    email: currentUser?.email,
    language: currentUser?.lang,
    is_admin: currentUser?.is_admin,
    phone: currentUser?.phone,
    company: {
      id: currentUser?.company_id,
      name: currentUser?.company_name,
    },
    z_index: 100,
  });
};

export const initializeIncognitoIntercom = () => {
  Intercom({
    app_id: process.env.NODE_ENV === 'production' ? 'xxw0e0bv' : 'cji4j4b4',
    z_index: 100,
  });
};
